import * as api from '../api/index'

import { ADD_NEW, UPDATE, DELETE, DELETE_ORDER, GET_INVOICE, FETCH_INVOICE_BY_USER, START_LOADING, END_LOADING, FETCH_DELETED_INVOICES, RESTORE_INVOICE, PERMANENT_DELETE_INVOICE } from './constants'
import { upsertOrderFromInvoice } from './orderActions'
import { selectAuthData } from '../store/selectors/authSelectors'

const INVOICE_CACHE_TTL = 5 * 60 * 1000
const serializeQuery = (query) => JSON.stringify(query || {})

// export const getInvoices = () => async (dispatch)=> {
//     try {
//         const { data } = await api.fetchInvoices()
//         dispatch({ type: FETCH_ALL, payload: data })
//     } catch (error) {
//         console.log(error)
//     }
// }

export const getInvoicesByUser =(searchQuery, options = {}) => async (dispatch, getState) => {
    const { force = false } = options
    const state = getState()
    const { lastFetched, lastQuery } = state?.invoices || {}
    const cacheKey = serializeQuery(searchQuery)
    const isFresh = lastFetched && Date.now() - lastFetched < INVOICE_CACHE_TTL
    if (!force && isFresh && lastQuery === cacheKey) {
        return
    }
    try {
      dispatch({ type: START_LOADING, meta: { cacheKey } })
      const  { data: { data } } = await api.fetchInvoicesByUser(searchQuery)
      dispatch({ type: FETCH_INVOICE_BY_USER, payload: { data, cacheKey, fetchedAt: Date.now() } });
    } catch (error) {
      console.log(error?.response || error)
    } finally {
      dispatch({ type: END_LOADING, meta: { cacheKey } })
    }
  }


export const getInvoice = (id) => async (dispatch, getState)=> {

    const auth = selectAuthData(getState())
    const userId = auth?.result?._id || auth?.result?.googleId

    try {
        const { data } = await api.fetchInvoice(id)
        const businessDetails = await api.fetchProfilesByUser({search: userId})
        const invoiceData = {...data, businessDetails}
        // console.log(invoiceData)
        dispatch({ type: GET_INVOICE, payload: invoiceData  })
    } catch (error) {
        console.log(error)
    }
}

export const createInvoice =(invoice, history) => async (dispatch) => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api.addInvoice(invoice)
        dispatch({ type: ADD_NEW, payload: data })
        dispatch(upsertOrderFromInvoice(data))
        history.push(`/invoice/${data._id}`)
        return data
    } catch (error) {
        console.log(error)
        throw error
    } finally {
        dispatch({ type: END_LOADING })
    }
}

export const updateInvoice =(id, invoice) => async (dispatch) => {

    try {
        const { data } = await api.updateInvoice(id, invoice)
        dispatch({ type: UPDATE, payload: data })
        dispatch(upsertOrderFromInvoice(data))
        return data
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const deleteInvoice =(id, openSnackbar, options = {}) => async (dispatch) => {
    try {
        const { data } = await api.deleteInvoice(id, options)

        dispatch({type: DELETE, payload: id})
        if (data?.deletedOrderId) {
            dispatch({ type: DELETE_ORDER, payload: data.deletedOrderId })
        }
        if (typeof openSnackbar === 'function') {
            openSnackbar(data?.message || 'Invoice moved to Recently Deleted')
        }
        return data
    } catch (error) {
        console.log(error?.response || error)
        throw error
    }
}

export const getDeletedInvoices = () => async (dispatch) => {
    try {
        dispatch({ type: START_LOADING });
        const { data: { data } } = await api.fetchDeletedInvoices();
        dispatch({ type: FETCH_DELETED_INVOICES, payload: data });
        dispatch({ type: END_LOADING });
    } catch (error) {
        console.log(error.response);
        dispatch({ type: END_LOADING });
    }
};

export const restoreInvoiceById = (id, openSnackbar) => async (dispatch) => {
    try {
        const { data } = await api.restoreInvoice(id);
        dispatch({ type: RESTORE_INVOICE, payload: data });
        if (typeof openSnackbar === "function") {
            openSnackbar("Invoice restored");
        }
    } catch (error) {
        console.log(error.response);
    }
};

export const deleteInvoicePermanentById = (id, openSnackbar) => async (dispatch) => {
    try {
        await api.deleteInvoicePermanent(id);
        dispatch({ type: PERMANENT_DELETE_INVOICE, payload: id });
        if (typeof openSnackbar === "function") {
            openSnackbar("Invoice deleted permanently");
        }
    } catch (error) {
        console.log(error.response);
    }
};
